<template>
  <div class="card-info">
    <div>
      <card-header></card-header>
      <tabs :tabs="tabs" :active="activeTab" @setTab="setTab" />
      <info v-if="activeTab === 0 && id" :id="id" />
      <participant v-if="activeTab === 1 && id" :id="id" />
    </div>
  </div>
</template>
<script>
import CardHeader from "./CardHeader";

import Info from "./Draw/Info";
import Participant from "./Draw/Participant";
import Tabs from "../Tabs";
import { errorNotify } from "../../plugins/functions";

export default {
  name: "draw",
  props: ["id"],
  components: {
    CardHeader,
    Tabs,
    Info,
    Participant,
  },
  data() {
    return {
      loading: true,
      tabs: [
        {
          title: "Информация",
        },
        {
          title: "Участники",
        },
      ],
      activeTab: 0,
    };
  },
  methods: {
    setTab(val) {
      this.activeTab = val;
    },
  },
  created() {},
};
</script>